import { H3 } from '@ahmdigital/ui';
import React from 'react';

import { BodyWrapper, ImageWrapper, StyledClickable, StyledDescription, StyledImage, TileWrapper } from './styles';
import { ImageObject, UrlObject } from '../../../../../../types/__codegen__/sanity/graphql';

export type DestinationProps = {
  cta: UrlObject;
  description: string;
  imageObject: ImageObject;
  title: string;
};

const DestinationTile = ({ cta, description, imageObject, title }: DestinationProps) => {
  const imageUrl = imageObject?.image?.asset?.url;

  return (
    <TileWrapper>
      {imageUrl && (
        <ImageWrapper>
          <StyledImage alt={imageObject.caption} src={imageUrl} />
        </ImageWrapper>
      )}
      <BodyWrapper>
        {title && <H3>{title}</H3>}
        {description && <StyledDescription>{description}</StyledDescription>}
        {cta && <StyledClickable to={cta.url}>{cta.name}</StyledClickable>}
      </BodyWrapper>
    </TileWrapper>
  );
};

export default DestinationTile;
